import { CircularProgress, Tooltip, Typography } from "@mui/material"
import { Link, routes } from '@cedarjs/router'
import AnimatedSlidingBlock from "../AnimatedSlidingBlock/AnimatedSlidingBlock"
import { useTranslation } from "react-i18next"
import { BatchInfosQuery } from "types/graphql"
import { useStateStore } from "src/lib/store"
import ReviewPopupButton from "../Review/ReviewPopupButton/ReviewPopupButton"

type HeaderBatchInfosProps = {
  batch?: BatchInfosQuery["batch"]
  loading?: boolean
  failed?: boolean
  className?: String
}
const HeaderBatchInfos = ({ batch = null, loading = false, failed = false, className = "" }: HeaderBatchInfosProps) => {
  const { t } = useTranslation()
  const [stadePL, daysOfCulture] = useStateStore(state => [state.stadePL, state.daysOfCulture])

  return (

    <div className={`flex flex-row gap-6 items-center ${className}`}>
      <AnimatedSlidingBlock key="header-batch">
        <Link to={!loading ? routes.batch({ idBatch: batch.id }) : ""} className="no-underline dark:text-white/80 text-black pb-0">
          <div className="flex flex-col align-items-center justify-center items-center hover:text-blue-800 transition-colors">
            <Typography variant="h2" className="font-bold sm:text-xl lg:text-2xl  text-lg">
              {loading
                ? <CircularProgress size={20} />
                : (
                  <Tooltip arrow title={
                    <div className="flex flex-col items-start align-middle whitespace-nowrap">
                      <Typography variant="body1" sx={{ fontWeight: 600 }} className="flex flex-row">
                        <span className="text-white/80 flex flex-row">DoC{daysOfCulture && <span className="text-white ml-1">{daysOfCulture}</span>}</span>
                        <span className="mx-1">/</span>
                        <span className="text-white/80 flex flex-row">PL{stadePL && <span className="text-white ml-1">{stadePL}</span>}</span>
                      </Typography>
                      <Typography variant="body2">
                        {batch.quantity} PL{batch.batchInitial ? batch.batchInitial.stadePL : batch.rootBatch.batchInitial.stadePL} {batch.batchInitial ? batch.batchInitial.provider.name : batch.rootBatch.batchInitial.provider.name}
                      </Typography>
                    </div>
                  }>
                    <span>{batch.name}</span>
                  </Tooltip>
                )}
            </Typography>
            <Typography variant="caption" className="sm:block hidden whitespace-nowrap">
              {`${t("labels.batch")}`}
            </Typography>
          </div>
        </Link>
      </AnimatedSlidingBlock>
      {batch?.currentTank &&
        <AnimatedSlidingBlock key="header-tank">
          <Link to={!loading ? routes.tank({ idSite: batch?.currentTank?.site?.id, idTank: batch?.currentTank?.id }) : ""} className="no-underline dark:text-white/80 text-black pb-0">
            <div className="flex flex-col align-items-center justify-center items-center hover:text-blue-800 transition-colors">
              <Typography variant="h2" className="font-bold sm:text-xl lg:text-2xl  text-lg">
                {loading ? <CircularProgress size={20} /> : (batch?.currentTank?.name)}
              </Typography>
              <Typography variant="caption" className="sm:block hidden whitespace-nowrap">
                {t("titles.actualTank")}
              </Typography>
            </div>
          </Link>
        </AnimatedSlidingBlock>
      }
      <AnimatedSlidingBlock key="header-state">
        {batch?.lastReview &&
          <div className="flex flex-col items-center justify-end h-full">
            <ReviewPopupButton review={batch?.lastReview} className="sm:text-xl lg:text-xl text-lg p-1" />
            <Typography variant="caption" className="sm:block hidden whitespace-nowrap">
              {t("labels.state")}
            </Typography>
          </div>}
      </AnimatedSlidingBlock>
    </div>
  )
}

export default HeaderBatchInfos
